<template>
    <div class="page-wrapper plug">
        <div class="container">
            <div class="row" style="row-gap: 2rem;">
                <div class="col-lg-5">
                    <div class="text-center">
                        <router-link to="/">
                            <img class="logo-img" src="@/img/logo-1.png" alt="Klub Partnerów Pirelli"/>
                        </router-link>
                    </div>
                </div>
                <div class="col-12 col-lg-10 offset-lg-1 text-center text-lg-start d-flex justify-content-center justify-content-lg-start align-items-center my-5">
                    <h2 class="fw400">
                        Już niedługo zapraszamy
                        <br/>
                        do nowej odsłony programu
                        <br/>
                        Klub Partnerów Pirelli
                    </h2>
                </div>
            </div>
        </div>
        <footer-component :is-plug="true"/>
    </div>
</template>

<script>
import FooterComponent from "@/components/modules/FooterComponent.vue";

export default {
    name: "PlugComponent",
    components: {FooterComponent},
}
</script>

<style lang="scss">
.page-wrapper.plug {
    background-image: url("@/img/plug-bg.webp");
    min-height: 100vh;
    padding-bottom: 120px;
    @media (min-width: 992px) {
        &-page-text {
            max-width: 550px;
            margin: 9rem 0 9.5rem;
        }

        .box {
            margin-top: 7.5rem;
        }
    }
    .logo-img{
        @media screen and (max-width: 1199px) {
            max-width: 300px;
        }
        @media screen and (max-width: 768px) {
            max-width: 200px;
        }
    }
}
</style>
